import React from 'react';
import { Check, FileText, Upload, Eye } from 'lucide-react';

const WizardProgress = ({ currentStep, totalSteps, onStepClick }) => {
  const steps = [
    {
      id: 1,
      title: 'Application Form',
      description: 'Fill out your application details',
      icon: FileText
    },
    {
      id: 2,
      title: 'Portfolio Upload',
      description: 'Upload your artwork and portfolio',
      icon: Upload
    },
    {
      id: 3,
      title: 'Review & Submit',
      description: 'Review your application and submit',
      icon: Eye
    }
  ];

  const getStepStatus = (step) => {
    if (step.id < currentStep) return 'completed';
    if (step.id === currentStep) return 'current';
    return 'upcoming';
  };

  return (
    <div className="step-progress">
      {steps.map((step, index) => {
        const status = getStepStatus(step);
        const isClickable = step.id <= currentStep + 1;
        
        return (
          <React.Fragment key={step.id}>
            <div 
              className={`step ${status} ${isClickable ? 'clickable' : ''}`}
              onClick={() => isClickable && onStepClick(step.id)}
            >
              <div className="step-number">
                {status === 'completed' ? (
                  <Check className="w-5 h-5" />
                ) : (
                  step.id
                )}
              </div>
              <div className="step-title">{step.title}</div>
              <div className="step-description">{step.description}</div>
            </div>
            
            {index < steps.length - 1 && (
              <div className="step-connector"></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardProgress;
